import { supabase } from '../lib/supabase';

export const assessmentService = {
  async saveAssessment(assessmentType, title, formData, results) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('assessment_results')?.insert({
        user_id: user?.id,
        assessment_type: assessmentType,
        title: title,
        form_data: formData,
        results: results
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  async getUserAssessments(userId) {
    const { data, error } = await supabase?.from('assessment_results')?.select('*')?.eq('user_id', userId)?.order('created_at', { ascending: false });

    if (error) throw error;
    return data;
  },

  async getAssessmentById(assessmentId) {
    const { data, error } = await supabase?.from('assessment_results')?.select('*')?.eq('id', assessmentId)?.single();

    if (error) throw error;
    return data;
  },

  async deleteAssessment(assessmentId) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase?.from('assessment_results')?.delete()?.eq('id', assessmentId)?.eq('user_id', user?.id);

    if (error) throw error;
  }
};